import { useRef, useState } from 'react'
import { ModalContext, type OpenModal } from './ModalContext'
import { Dialog } from '@mui/material'

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [content, setContent] = useState<React.ReactNode | null>(null)
  const resolverRef = useRef<((value: unknown) => void) | null>(null)

  const close = () => {
    setContent(null)
  }

  const openModal: OpenModal = (render) => {
    return new Promise((resolve) => {
      resolverRef.current = resolve as (value: unknown) => void

      setContent(
        render({
          cancelModal: close,
          setModalSuccess: (value) => {
            resolve(value)
            close()
          },
        }),
      )
    })
  }

  return (
    <ModalContext.Provider value={{ openModal }}>
      {children}

      <Dialog open={!!content} onClose={close} maxWidth="sm" fullWidth>
        {content}
      </Dialog>
    </ModalContext.Provider>
  )
}
